import React, { useState } from "react"

import TimelineEvent from "./timeline-event"
import Switch from "../switch/switch"

const Timeline = props => {
  let timelineContent = props.timelineContent
  //console.log("events", timelineContent.timelineEvents.length)

  let [descriptionIsOpen, setDescriptionIsOpen] = useState(false)
  let [isChecked, setIsChecked] = useState(false)

  let toggleDescription = () => {
    descriptionIsOpen ? setDescriptionIsOpen(false) : setDescriptionIsOpen(true)
    toggleCheck()
  }
  function toggleCheck() {
    descriptionIsOpen ? setIsChecked(false) : setIsChecked(true)
  }

  const buildTimeline = () => {
    let timelineBuild = timelineContent.timelineEvents.map(
      (timelineEvent, i) => {
        return (
          <TimelineEvent
            key={"i" + i}
            time={timelineEvent.time}
            title={timelineEvent.title}
            location={timelineEvent.location}
            description={timelineEvent.description}
            className={descriptionIsOpen}
          />
        )
      }
    )
    return timelineBuild
  }
  return (
    <section
      className={
        descriptionIsOpen
          ? "timeline timeline-details-on"
          : "timeline timeline-details-off"
      }
    >
      <div className="container">
        <Switch onClick={toggleDescription} checked={isChecked} />
      </div>
      <div className="container">{buildTimeline()}</div>
    </section>
  )
}

export default Timeline
